// extracted by mini-css-extract-plugin
export default {"block":"Tag_block__MY2TZ","selected":"Tag_selected__oUFD5","delete":"Tag_delete__HjD0X"};